import React, { useState } from 'react';
import { Rocket, Radar } from 'lucide-react';
import ExpansionSignals from './ExpansionSignals';
import JobLeadDiscovery from './JobLeadDiscovery';

const MODES = [
  { key: 'expansion', label: 'Expansion Signals', icon: Rocket, Component: ExpansionSignals },
  { key: 'joblead', label: 'Job Leads Context', icon: Radar, Component: JobLeadDiscovery },
];

export default function GrowthExpansionView({ embedded = false, initialMode = 'expansion' }) {
  const [mode, setMode] = useState(MODES.some(m => m.key === initialMode) ? initialMode : 'expansion');
  const ActiveMode = MODES.find(m => m.key === mode)?.Component || ExpansionSignals;

  return (
    <div>
      <div className="flex items-center gap-2 bg-white border-b border-gray-200 px-6 py-3" data-testid="growth-expansion-mode-toggle">
        {MODES.map(m => (
          <button
            key={m.key}
            onClick={() => setMode(m.key)}
            data-testid={`growth-mode-${m.key}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full border transition-colors ${
              mode === m.key ? 'bg-[#0A1F44] text-white border-[#0A1F44]' : 'bg-white text-gray-500 border-gray-200 hover:border-[#0A1F44]/40'
            }`}
          >
            <m.icon className="h-3 w-3" /> {m.label}
          </button>
        ))}
      </div>
      <ActiveMode embedded={embedded} />
    </div>
  );
}
